import { render, staticRenderFns } from "./bound-group.vue?vue&type=template&id=305be7e5&scoped=true"
import script from "./bound-group.vue?vue&type=script&lang=ts"
export * from "./bound-group.vue?vue&type=script&lang=ts"
import style0 from "./bound-group.vue?vue&type=style&index=0&id=305be7e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305be7e5",
  null
  
)

export default component.exports